'use strict';

var storage = require('./storage'),
    Epg = require('./epg.class.js');


function Channel ( config ) {
    var key;

    config = config || {};

    for ( key in config ) {
        this[key] = config[key];
    }
    this.favorite = storage.favoriteList.indexOf(this.id) !== -1;
}


/**
 * Toggle favorite state
 *
 * @param {Function} callback - callback after toggle
 */
Channel.prototype.toggleFavorite = function ( callback ) {
    var index;

    this.favorite = !this.favorite;

    if ( this.favorite ) {
        storage.favoriteList.push(this.id);
    } else {
        index = storage.favoriteList.indexOf(this.id);
        if ( index !== -1 ) {
            storage.favoriteList.splice(index, 1);
        }
    }

    storage.data.setItem('favoriteList', storage.favoriteList);
    callback(false, this.favorite);
};


Channel.prototype.getUrl = function ( callback ) {
    callback(false, {url: this.url, solution: this.solution});
};


Channel.prototype.getEpg = function ( config, callback ) {
    var data,
        result = [],
        now = new Date(),
        from, to, index;

    config = config || {};

    // use 7 days before current and next 7 days to get epg
    from = +new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
    to =  +new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7);
    from = Math.round(from / 1000);
    to  = Math.round(to / 1000);

    from = config.from || from;
    to = config.to || to;

    try {
        data = dvbManager.GetEPGScheduleByRange(this.id, from, to);
        if ( data === '' || data === '{}' ) {
            if ( callback ) {
                callback(false, []);
            }

            return result;
        }
        data = JSON.parse(data);
    } catch ( error ) {
        console.log(error);
        if ( callback ) {
            callback(error, []);
        }

        return result;
    }

    for ( index = 0; index < data.events.length; index++ ) {
        data.events[index].channel = this;
        result.push(new Epg(data.events[index]));
    }
    if ( callback ) {
        callback(false, result);
    }

    return result;
};


Channel.prototype.getEPGBrief = function ( callback ) {
    var data = dvbManager.GetEPGBrief(this.id),
        result;

    if ( data === '' || data === '{}' ) {
        if ( callback ) {
            callback(true);
        }

        return null;
    }

    try {
        data = JSON.parse(data);
    } catch ( error ) {
        console.log(error);
        if ( callback ) {
            callback(true);
        }

        return null;
    }

    if ( !data.events || data.events.length === 0 ) {
        if ( callback ) {
            callback(true);
        }

        return null;
    }

    data.events[0].channel = this;
    result = new Epg(data.events[0]);
    if ( callback ) {
        callback(false, result);
    }

    return result;
};


Channel.prototype.setLast = function () {
    storage.data.setItem('lastChannel', this.id);
};


Channel.prototype.remove = function () {
    dvbManager.RemoveChannel(this.id);
};


module.exports = Channel;
